"use strict";
// Pure state contract for later native selling-plan integration. No IDs or prices are invented here.
function resolvePurchase({mode,variant,quantity,planId}) {
 const reject=reason=>({ok:false,mode,reason,payload:null,priceMinor:null});
 if(!variant||!/^[1-9][0-9]*$/.test(String(variant.id)))return reject('variant_missing');
 if(!variant.available)return reject('unavailable');
 const min=variant.min??1,step=variant.step??1,max=variant.max??Infinity;
 if(!Number.isSafeInteger(quantity)||quantity<min||quantity>max||(quantity-min)%step!==0)return reject('invalid_quantity');
 if(mode==='one_time'){
  if(!Number.isSafeInteger(variant.priceMinor)||variant.priceMinor<0)return reject('price_missing');
  return {ok:true,mode,payload:{id:String(variant.id),quantity},priceMinor:variant.priceMinor,currency:variant.currency,recurring:false};
 }
 if(mode!=='subscription')return reject('invalid_mode');
 const plan=variant.plans?.find(p=>String(p.id)===String(planId));
 if(!plan||!plan.verified||!plan.recurring||String(plan.nativeVariantId)!==String(variant.id))return reject('plan_unavailable');
 if(plan.currency!==variant.currency)return reject('currency_mismatch');
 if(!Number.isSafeInteger(plan.priceMinor)||plan.priceMinor<0||plan.priceMinor!==plan.verifiedPriceMinor)return reject('plan_price_changed');
 return {ok:true,mode,payload:{id:String(variant.id),quantity,selling_plan:String(plan.id)},priceMinor:plan.priceMinor,currency:plan.currency,recurring:true,period:plan.period};
}
if(typeof module!=="undefined"&&module.exports)module.exports={resolvePurchase};else globalThis.RejuviaPurchase={resolvePurchase};
